import { map } from '@/api/map'
import store from '@/store'
import Vue from 'vue'

let res = null

export const maps = {
    namespaced: true,
    state: {
        searchCaregiver: null, //조회한 종사자 리스트
        searchSenior: null, //조회한 수급자 리스트
        selectSeniorList: null,
        selectStaffList: null,
        currentSchedule: null,
        userMemo: null,
        profileGender: null,
        profileSalary: null,
        profileTime: null,
        profileType: null
    },
    mutations: {
        SEARCH_CURRENT_MAP(state, payload) {
            state.searchCaregiver = payload.staffList
        },
        GET_SELECT_LIST(state, payload) {
            state.selectSeniorList = payload.list
            state.selectStaffList = payload.staffList
        },
        CLEAR_SEARCH(state) {
            state.searchCaregiver = null
        },
        CARE_SCHEDULE(state, payload) {
            state.currentSchedule = payload.list
        },
        RESET_SCHEDULE(state) {
            state.currentSchedule = null
        },
        USER_MAP_MEMO(state, payload) {
            if (payload.memoList) {
                if (!state.userMemo) state.userMemo = []
                state.userMemo = state.userMemo.concat(payload.memoList)
            }
        },
        REGIST_MAP_MEMO(state, payload) {
            if (!state.userMemo) state.userMemo = []
            state.userMemo.unshift(payload.memo)
        },
        DELETE_MAP_MEMO(state, payload) {
            let index = state.userMemo.findIndex(item => item.staffSearchMemoIdx === payload)
            if (index !== -1) {
                state.userMemo.splice(index, 1)
            }

            if (!state.userMemo.length) state.userMemo = null
        },
        RESET_MEMO(state) {
            state.userMemo = null
        },
        USER_PROFILE(state, payload) {
            state.profileGender = payload.profileGender
            state.profileSalary = payload.profileSalary
            state.profileTime = payload.profileTime
            state.profileType = payload.profileType
        },
        RESET_PROFILE(state) {
            state.profileGender = null
            state.profileSalary = null
            state.profileTime = null
            state.profileType = null
        },
        SEARCH_SENIOR_MAP(state, payload) {
            state.searchSenior = payload.seniorList
            console.log(state.searchSenior)
        }
    },
    actions: {
        // @Description 현재화면에서 조회
        async SEARCH_CURRENT_MAP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.get.searchCaregiver(payload)
                console.log('SEARCH_CURRENT_MAP info', res)
                if (res.data.status === 200) {
                    commit('SEARCH_CURRENT_MAP', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SEARCH_CURRENT_MAP error', error)
            }
        },
        // @Description 수급자/시니어/종사자 전체조회
        async GET_SELECT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.get.searchSenior(payload)
                console.log('GET_SELECT_LIST info', res)
                if (res.data.status === 200) {
                    commit('GET_SELECT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_SELECT_LIST error', error)
            }
        },
        // @Description 상세보기 일정 조회
        async CARE_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.get.caregiverSchedule(payload)
                console.log('CARE_SCHEDULE info', res)
                if (res.data.status === 200) {
                    commit('CARE_SCHEDULE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CARE_SCHEDULE error', error)
            }
        },
        // @Description 상세보기 일정 조회
        async CHECK_STAFF_STATE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.get.checkStaffState(payload)
                console.log('CHECK_STAFF_STATE info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHECK_STAFF_STATE error', error)
            }
        },
        // @Description 상세보기 메모 조회
        async USER_MAP_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.get.searchMemo(payload)
                console.log('USER_MAP_MEMO info', res)
                if (res.data.status === 200) {
                    commit('USER_MAP_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('USER_MAP_MEMO error', error)
            }
        },
        // @Description 메모작성
        async REGIST_MAP_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.post.searchMemo(payload)
                console.log('REGIST_MAP_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_MAP_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_MAP_MEMO error', error)
            }
        },
        // @Description 메모삭제
        async DELETE_MAP_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.delete.searchMemo(payload)
                console.log('DELETE_MAP_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_MAP_MEMO', payload.staffSearchMemoIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_MAP_MEMO error', error)
            }
        },
        // @Description 구직희망자 등록
        async REGIST_USER({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.post.otherMember(payload)
                console.log('REGIST_USER info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message + '. 구직희망자의 주소지로 이동해서 검색해주세요.', color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_USER error', error)
            }
        },
        // @Description 일자리유형 조회
        async USER_PROFILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.get.profile(payload)
                console.log('USER_PROFILE info', res)
                if (res.data.status === 200) {
                    commit('USER_PROFILE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('USER_PROFILE error', error)
            }
        },
        // @Description 종사자 중심으로 조회
        async SEARCH_SENIOR_MAP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await map.get.searchSeniorMap(payload)
                console.log('SEARCH_SENIOR_MAP info', res)
                if (res.data.status === 200) {
                    commit('SEARCH_SENIOR_MAP', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SEARCH_SENIOR_MAP error', error)
            }
        },
    },
    getters: {
        CURRENT_SCHEDULE: state => {
            if (state.currentSchedule) {
                let arr = state.currentSchedule.deepCopy()
                arr.forEach(item => {
                    item['start'] = `${item.offerYmd.ymdMask()} 10:00:00`
                    item['end'] = `${item.offerYmd.ymdMask()} 12:00:00`
                    item['color'] = 'white'
                })
                return arr
            } else {
                return []
            }
        },

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/maps.js